var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "VisitorMetaReferralsCard" } }, [
    _c(
      "div",
      { attrs: { id: "chatCard" } },
      [
        _c("div", { staticClass: "headtitle" }, [
          _c("span", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("userInfoWidget.adsYouAreInterestedIn"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-row" },
            [
              _c(
                "a-button",
                {
                  staticClass:
                    "justify-content-around pl-3 popoverFont cursorPointer",
                  attrs: { ghost: "", id: "forwardButton" },
                  on: {
                    click: function ($event) {
                      _vm.modaladvertisingdetail = true
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: { icon: "share" },
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("userInfoWidget.detail")) +
                      "\n                "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("userInfoWidget.adsTitle")))]),
              _vm._v(" "),
              _c("th"),
              _vm._v(" "),
              _c("th", [
                _vm._v(
                  _vm._s(_vm.$t("userInfoWidget.adUrl")) + "\n                "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.metaReferrals || [], function (referral) {
              return _c("tr", { key: referral._id }, [
                _c(
                  "td",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                }",
                      },
                    ],
                    staticStyle: { width: "200px" },
                    attrs: { content: referral.headline },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          referral.headline.length > 100
                            ? referral.headline.substring(0, 100) + "..."
                            : referral.headline
                        ) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("td"),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                }",
                      },
                    ],
                    attrs: { content: referral.sourceLink },
                  },
                  [
                    referral.sourceLink && referral.sourceLink.length
                      ? _c("span", [
                          _c(
                            "a",
                            {
                              staticClass: "text-truncate",
                              attrs: {
                                href: referral.sourceLink,
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(referral.sourceLink) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("wp.notAvailable")) +
                              "\n                        "
                          ),
                        ]),
                  ]
                ),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm.modaladvertisingdetail
          ? _c("VisitorMetaReferralsModal", {
              attrs: {
                metaReferrals: _vm.metaReferrals,
                modaladvertisingdetail: _vm.modaladvertisingdetail,
              },
              on: {
                close: function ($event) {
                  _vm.modaladvertisingdetail = false
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }